function Body() {
  return (
    <div className="Body_main">
      <div className="Body_slogan">Unlock Your Dream Job in Full Stack</div>
      <div className="Body_caption">Master React, Node, Javascript and Java</div>
    </div>
  );
}
export default Body;